import { Modal, Paper, Button, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "components/pages/transmissions/modal/hl7job/hl7JobModal.css";
import LoadingSpinner from "components/LoadingSpinner";
import { useSelector, useDispatch } from "react-redux";
import {
  toggleModal,
  toggleProcessing,
} from "app/store/transmission/slice/transmissionSlice";
import { useProcessBulkHl7JobsMutation } from "app/store/transmission/api/transmissionTableApi";
import { showSuccessToast, showErrorToast } from "utils/toast";

const Hl7JobModal = ({ setRowSelection }) => {
  const { totalSelectedRows, selectedReports, isProcessing } = useSelector(
    (state) => state.transmission
  );
  const dispatch = useDispatch();
  const [processBulkHl7Jobs] = useProcessBulkHl7JobsMutation();

  const onConfirm = async () => {
    try {
      dispatch(toggleProcessing(true));
      const response = await processBulkHl7Jobs(selectedReports).unwrap();
      const { message } = response;

      if (!response?.error) {
        showSuccessToast(message);
        setRowSelection?.({});
      }
    } catch (error) {
      showErrorToast(error?.message || "An error occured, please try later.");
    } finally {
      dispatch(toggleProcessing(false));
      dispatch(toggleModal({ type: "hl7job", value: false }));
    }
  };

  const onClose = (event, reason) => {
    if (reason === "backdropClick") {
      event.stopPropagation();
    } else {
      dispatch(toggleProcessing(false));
      dispatch(toggleModal({ type: "hl7job", value: false }));
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={true}
        onClose={onClose}
      >
        <div className="process-modal__container">
          <Paper>
            <div className="process-modal__wrapper">
              <Tooltip title="Close" placement="bottom">
                <div onClick={onClose} className="process-modal__close">
                  <CloseIcon />
                </div>
              </Tooltip>
              <div className="process-modal__text">
                {isProcessing ? (
                  <div>
                    <div className="process-modal__processing">
                      Exporting
                      {totalSelectedRows}{" "}
                      {totalSelectedRows > 1 ? "reports" : "report"} to EHR.
                    </div>
                    <div className="process-modal__spinner">
                      <LoadingSpinner color="secondary" />
                    </div>
                  </div>
                ) : (
                  <div>
                    {totalSelectedRows === 1 && (
                      <div>
                        Are you sure you want to Export 1 report to EHR?
                      </div>
                    )}
                    {totalSelectedRows > 1 && (
                      <div>
                        Are you sure you want to Export {totalSelectedRows}{" "}
                        reports to EHR?
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="process-modal__buttons">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onConfirm}
                  disabled={isProcessing}
                >
                  Export to EHR
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={onClose}
                  disabled={isProcessing}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      </Modal>
    </div>
  );
};

export default Hl7JobModal;
